"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidateReferralResponse = exports.ValidateReferralRequest = exports.ThankYouResultData = exports.SaveWorkflowResponse = exports.SaveWorkflowRequest = exports.EEOQuestionUserResponse = exports.EEOQuestionsResultData = exports.SubmitResultData = exports.AttachmentResultData = exports.ResumeEntryValue = exports.ResumeEntry = exports.SectionResultData = exports.ResumeStructureResultData = exports.SocialResumeInfo = exports.ContactDetailsResultData = exports.ResumeResultData = exports.PreferredCommunicationResultData = exports.ContactInfoResultData = exports.PrescreeningResultData = exports.PrescreeningResultDataSection = exports.PrescreeningResultDataAnswer = exports.PrescreeningResultDataResponse = exports.DisclaimerResultData = exports.CustomIntegrationResultData = exports.NoteResultData = exports.ThankYouActionItem = exports.ApplyWithIntegration = exports.PreferredCommunicationActionItem = exports.ContactInfoActionItem = exports.SubmitActionItem = exports.FileUploadField = exports.PMCDropdownListItem = exports.PMCDropdownField = exports.DropdownField = exports.PhoneField = exports.Field = exports.FieldOptions = exports.ResumeField = exports.Section = exports.ResumeStructure = exports.ContactDetails = exports.CoverLetterActionItem = exports.AttachmentFileUpload = exports.AttachmentActionItem = exports.ResumeActionItem = exports.EEOResponse = exports.EEOQuestion = exports.EEOActionItem = exports.PrescreeningQuestionOption = exports.PrescreeningQuestion = exports.PrescreeningSection = exports.PrescreeningActionItem = exports.DisclaimerActionItem = exports.CustomIntegrationActionItem = exports.NoteActionItem = exports.ValidatedCustomIntegrationAction = exports.ValidatedResumeAction = exports.ValidatedPreferredCommunicationAction = exports.ValidatedContactInfoAction = exports.ValidatedEEOQuestionsAction = exports.ValidatedPrescreeningAction = exports.PrescreeningQuestionValidationError = exports.ValidatedDisclaimerAction = exports.ValidationError = exports.SavedWorkflowResponse = exports.SubmitWorkflowResponse = exports.ApplyWithIntegrationResponse = exports.LaunchCustomIntegrationRequest = exports.LaunchCustomIntegrationResponse = exports.TagsReplacementRequest = exports.ParseResumeResponse = exports.ValidateAnonymousEmailResponse = exports.ValidatedWorkflowItems = exports.ErrorResponse = exports.ApplicationWorkflowPage = exports.CustomIntegrationStatus = exports.ActionType = void 0;
var ApplicationActions_1 = require("../../actions/ApplicationActions");
var ActionType;
(function (ActionType) {
    ActionType[ActionType["note"] = 'note'] = "note";
    ActionType[ActionType["prescreeningQuestions"] = 'prescreeningQuestions'] = "prescreeningQuestions";
    ActionType[ActionType["eeoQuestions"] = 'eeoQuestions'] = "eeoQuestions";
    ActionType[ActionType["resume"] = 'resume'] = "resume";
    ActionType[ActionType["submit"] = 'submit'] = "submit";
    ActionType[ActionType["disclaimer"] = 'disclaimer'] = "disclaimer";
    ActionType[ActionType["thankYou"] = 'thankYou'] = "thankYou";
    ActionType[ActionType["contactInformation"] = 'contactInformation'] = "contactInformation";
    ActionType[ActionType["customIntegration"] = 'customIntegration'] = "customIntegration";
    ActionType[ActionType["interviewIntegration"] = 'interviewIntegration'] = "interviewIntegration";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
var CustomIntegrationStatus;
(function (CustomIntegrationStatus) {
    CustomIntegrationStatus[CustomIntegrationStatus["pending"] = 'pending'] = "pending";
    CustomIntegrationStatus[CustomIntegrationStatus["inProgress"] = 'inProgress'] = "inProgress";
    CustomIntegrationStatus[CustomIntegrationStatus["completed"] = 'completed'] = "completed";
})(CustomIntegrationStatus = exports.CustomIntegrationStatus || (exports.CustomIntegrationStatus = {}));
var ApplicationWorkflowPage = (function () {
    function ApplicationWorkflowPage() {
    }
    return ApplicationWorkflowPage;
}());
exports.ApplicationWorkflowPage = ApplicationWorkflowPage;
var ErrorResponse = (function () {
    function ErrorResponse() {
    }
    return ErrorResponse;
}());
exports.ErrorResponse = ErrorResponse;
var ValidatedWorkflowItems = (function () {
    function ValidatedWorkflowItems() {
    }
    return ValidatedWorkflowItems;
}());
exports.ValidatedWorkflowItems = ValidatedWorkflowItems;
var ValidateAnonymousEmailResponse = (function () {
    function ValidateAnonymousEmailResponse() {
    }
    return ValidateAnonymousEmailResponse;
}());
exports.ValidateAnonymousEmailResponse = ValidateAnonymousEmailResponse;
var ParseResumeResponse = (function () {
    function ParseResumeResponse() {
    }
    return ParseResumeResponse;
}());
exports.ParseResumeResponse = ParseResumeResponse;
var TagsReplacementRequest = (function () {
    function TagsReplacementRequest() {
    }
    return TagsReplacementRequest;
}());
exports.TagsReplacementRequest = TagsReplacementRequest;
var LaunchCustomIntegrationResponse = (function () {
    function LaunchCustomIntegrationResponse() {
        this.launchURL = '';
        this.jobApplicationId = null;
        this.integrationOrderId = null;
    }
    return LaunchCustomIntegrationResponse;
}());
exports.LaunchCustomIntegrationResponse = LaunchCustomIntegrationResponse;
var LaunchCustomIntegrationRequest = (function () {
    function LaunchCustomIntegrationRequest() {
        this.jobApplicationId = null;
    }
    return LaunchCustomIntegrationRequest;
}());
exports.LaunchCustomIntegrationRequest = LaunchCustomIntegrationRequest;
var ApplyWithIntegrationResponse = (function () {
    function ApplyWithIntegrationResponse() {
    }
    return ApplyWithIntegrationResponse;
}());
exports.ApplyWithIntegrationResponse = ApplyWithIntegrationResponse;
var SubmitWorkflowResponse = (function () {
    function SubmitWorkflowResponse() {
    }
    return SubmitWorkflowResponse;
}());
exports.SubmitWorkflowResponse = SubmitWorkflowResponse;
var SavedWorkflowResponse = (function () {
    function SavedWorkflowResponse() {
    }
    return SavedWorkflowResponse;
}());
exports.SavedWorkflowResponse = SavedWorkflowResponse;
var ValidationError = (function () {
    function ValidationError() {
    }
    return ValidationError;
}());
exports.ValidationError = ValidationError;
var ValidatedDisclaimerAction = (function () {
    function ValidatedDisclaimerAction() {
        this.type = ActionType.disclaimer;
    }
    return ValidatedDisclaimerAction;
}());
exports.ValidatedDisclaimerAction = ValidatedDisclaimerAction;
var PrescreeningQuestionValidationError = (function () {
    function PrescreeningQuestionValidationError() {
    }
    return PrescreeningQuestionValidationError;
}());
exports.PrescreeningQuestionValidationError = PrescreeningQuestionValidationError;
var ValidatedPrescreeningAction = (function () {
    function ValidatedPrescreeningAction() {
        this.type = ActionType.prescreeningQuestions;
    }
    return ValidatedPrescreeningAction;
}());
exports.ValidatedPrescreeningAction = ValidatedPrescreeningAction;
var ValidatedEEOQuestionsAction = (function () {
    function ValidatedEEOQuestionsAction() {
        this.type = ActionType.eeoQuestions;
        this.errors = new Array();
    }
    return ValidatedEEOQuestionsAction;
}());
exports.ValidatedEEOQuestionsAction = ValidatedEEOQuestionsAction;
var ValidatedContactInfoAction = (function () {
    function ValidatedContactInfoAction() {
        this.type = ActionType.contactInformation;
        this.errors = new Array();
    }
    return ValidatedContactInfoAction;
}());
exports.ValidatedContactInfoAction = ValidatedContactInfoAction;
var ValidatedPreferredCommunicationAction = (function () {
    function ValidatedPreferredCommunicationAction() {
        this.type = ActionType.interviewIntegration;
        this.errors = new Array();
    }
    return ValidatedPreferredCommunicationAction;
}());
exports.ValidatedPreferredCommunicationAction = ValidatedPreferredCommunicationAction;
var ValidatedResumeAction = (function () {
    function ValidatedResumeAction() {
        this.type = ActionType.resume;
        this.errors = new Array();
    }
    return ValidatedResumeAction;
}());
exports.ValidatedResumeAction = ValidatedResumeAction;
var ValidatedCustomIntegrationAction = (function () {
    function ValidatedCustomIntegrationAction() {
        this.type = ActionType.customIntegration;
    }
    return ValidatedCustomIntegrationAction;
}());
exports.ValidatedCustomIntegrationAction = ValidatedCustomIntegrationAction;
var NoteActionItem = (function () {
    function NoteActionItem() {
        this.type = ActionType.note;
        this.getActionTypeName = function () {
            return 'Note';
        };
    }
    return NoteActionItem;
}());
exports.NoteActionItem = NoteActionItem;
var CustomIntegrationActionItem = (function () {
    function CustomIntegrationActionItem() {
        this.type = ActionType.customIntegration;
        this.getActionTypeName = function () {
            return 'CustomIntegration';
        };
        this.launchURL = '';
        this.integrationOrderId = null;
        this.applicationId = null;
    }
    return CustomIntegrationActionItem;
}());
exports.CustomIntegrationActionItem = CustomIntegrationActionItem;
var DisclaimerActionItem = (function () {
    function DisclaimerActionItem() {
        this.type = ActionType.disclaimer;
        this.getActionTypeName = function () {
            return 'Disclaimer';
        };
    }
    return DisclaimerActionItem;
}());
exports.DisclaimerActionItem = DisclaimerActionItem;
var PrescreeningActionItem = (function () {
    function PrescreeningActionItem() {
        this.type = ActionType.prescreeningQuestions;
        this.getActionTypeName = function () {
            return 'PrescreeningQuestions';
        };
    }
    return PrescreeningActionItem;
}());
exports.PrescreeningActionItem = PrescreeningActionItem;
var PrescreeningSection = (function () {
    function PrescreeningSection() {
    }
    return PrescreeningSection;
}());
exports.PrescreeningSection = PrescreeningSection;
var PrescreeningQuestion = (function () {
    function PrescreeningQuestion() {
    }
    return PrescreeningQuestion;
}());
exports.PrescreeningQuestion = PrescreeningQuestion;
var PrescreeningQuestionOption = (function () {
    function PrescreeningQuestionOption() {
        this.isChecked = false;
    }
    return PrescreeningQuestionOption;
}());
exports.PrescreeningQuestionOption = PrescreeningQuestionOption;
var EEOActionItem = (function () {
    function EEOActionItem() {
        this.type = ActionType.eeoQuestions;
        this.getActionTypeName = function () {
            return 'EEOQuestions';
        };
        this.eeoQuestions = new Array();
    }
    return EEOActionItem;
}());
exports.EEOActionItem = EEOActionItem;
var EEOQuestion = (function () {
    function EEOQuestion() {
        this.responses = new Array();
    }
    return EEOQuestion;
}());
exports.EEOQuestion = EEOQuestion;
var EEOResponse = (function () {
    function EEOResponse() {
    }
    return EEOResponse;
}());
exports.EEOResponse = EEOResponse;
var ResumeActionItem = (function () {
    function ResumeActionItem() {
        this.type = ActionType.resume;
        this.getActionTypeName = function () {
            return 'Resume';
        };
    }
    return ResumeActionItem;
}());
exports.ResumeActionItem = ResumeActionItem;
var AttachmentActionItem = (function () {
    function AttachmentActionItem() {
        this.errorMessage = '';
        this.fileUploads = [];
    }
    Object.defineProperty(AttachmentActionItem.prototype, "allowMoreAttachments", {
        get: function () {
            return this.fileUploads.length < 10 && this.fileUploads.every(function (fileUpload) { return !fileUpload.token.showUpload; });
        },
        enumerable: false,
        configurable: true
    });
    AttachmentActionItem.prototype.addNewFileUpload = function () {
        var fileIdx = this.fileUploads.length;
        var fileUpload = new AttachmentFileUpload();
        fileUpload.setIds(this.index, this.attachmentId, fileIdx);
        fileUpload.resetTokenValue();
        this.fileUploads.push(fileUpload);
        return fileUpload;
    };
    AttachmentActionItem.prototype.deleteFileUpload = function (fileUploadIndex) {
        var _this = this;
        if (this.fileUploads.length === 1) {
            var fileUpload = this.fileUploads[fileUploadIndex];
            fileUpload.token.fileUrl = '';
            fileUpload.token.deleteUrl = '';
            fileUpload.token.title = '';
            fileUpload.token.fileSize = '0';
            fileUpload.token.showUpload = true;
        }
        else {
            this.fileUploads.splice(fileUploadIndex, 1);
            this.fileUploads.forEach(function (fileUpload, fileIdx) {
                fileUpload.setIds(_this.index, _this.attachmentId, fileIdx);
            });
        }
    };
    return AttachmentActionItem;
}());
exports.AttachmentActionItem = AttachmentActionItem;
var AttachmentFileUpload = (function () {
    function AttachmentFileUpload() {
        this.token = new FileUploadField();
    }
    AttachmentFileUpload.prototype.setIds = function (attachmentIndex, attachmentId, fileUploadIndex) {
        this.id = "attachment_upload_" + attachmentIndex + "_" + attachmentId + "_" + fileUploadIndex;
        this.fileViewerId = "attachment_viewer_" + attachmentIndex + "_" + attachmentId + "_" + fileUploadIndex;
    };
    AttachmentFileUpload.prototype.resetTokenValue = function () {
        this.token.value = ApplicationActions_1.createUUID();
    };
    return AttachmentFileUpload;
}());
exports.AttachmentFileUpload = AttachmentFileUpload;
var CoverLetterActionItem = (function () {
    function CoverLetterActionItem() {
        this.isVisible = false;
        this.isRequired = false;
        this.coverLetterText = '';
        this.errorMessage = '';
    }
    return CoverLetterActionItem;
}());
exports.CoverLetterActionItem = CoverLetterActionItem;
var ContactDetails = (function () {
    function ContactDetails() {
    }
    return ContactDetails;
}());
exports.ContactDetails = ContactDetails;
var ResumeStructure = (function () {
    function ResumeStructure() {
    }
    return ResumeStructure;
}());
exports.ResumeStructure = ResumeStructure;
var Section = (function () {
    function Section() {
    }
    return Section;
}());
exports.Section = Section;
var ResumeField = (function () {
    function ResumeField() {
    }
    return ResumeField;
}());
exports.ResumeField = ResumeField;
var FieldOptions = (function () {
    function FieldOptions() {
    }
    return FieldOptions;
}());
exports.FieldOptions = FieldOptions;
var Field = (function () {
    function Field() {
    }
    Object.defineProperty(Field.prototype, "isValueTrue", {
        get: function () {
            return this.value.toString().toLowerCase() === "true";
        },
        enumerable: false,
        configurable: true
    });
    return Field;
}());
exports.Field = Field;
var PhoneField = (function () {
    function PhoneField() {
    }
    return PhoneField;
}());
exports.PhoneField = PhoneField;
var DropdownField = (function (_super) {
    __extends(DropdownField, _super);
    function DropdownField() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DropdownField;
}(Field));
exports.DropdownField = DropdownField;
var PMCDropdownField = (function () {
    function PMCDropdownField() {
    }
    return PMCDropdownField;
}());
exports.PMCDropdownField = PMCDropdownField;
var PMCDropdownListItem = (function () {
    function PMCDropdownListItem() {
    }
    return PMCDropdownListItem;
}());
exports.PMCDropdownListItem = PMCDropdownListItem;
var FileUploadField = (function (_super) {
    __extends(FileUploadField, _super);
    function FileUploadField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fileSize = '';
        _this.fileUrl = '';
        _this.fileIcon = '';
        _this.fileIconBackgroundColor = '';
        _this.deleteUrl = '';
        _this.showUpload = true;
        _this.brandIcon = '';
        return _this;
    }
    return FileUploadField;
}(Field));
exports.FileUploadField = FileUploadField;
var SubmitActionItem = (function () {
    function SubmitActionItem() {
        this.type = ActionType.submit;
        this.getActionTypeName = function () {
            return 'Submit';
        };
    }
    return SubmitActionItem;
}());
exports.SubmitActionItem = SubmitActionItem;
var ContactInfoActionItem = (function () {
    function ContactInfoActionItem() {
        this.type = ActionType.contactInformation;
        this.getActionTypeName = function () {
            return 'ContactInfo';
        };
    }
    return ContactInfoActionItem;
}());
exports.ContactInfoActionItem = ContactInfoActionItem;
var PreferredCommunicationActionItem = (function () {
    function PreferredCommunicationActionItem() {
        this.type = ActionType.interviewIntegration;
        this.getActionTypeName = function () {
            return 'PreferredCommunicationMethod';
        };
    }
    return PreferredCommunicationActionItem;
}());
exports.PreferredCommunicationActionItem = PreferredCommunicationActionItem;
var ApplyWithIntegration = (function () {
    function ApplyWithIntegration() {
    }
    return ApplyWithIntegration;
}());
exports.ApplyWithIntegration = ApplyWithIntegration;
var ThankYouActionItem = (function () {
    function ThankYouActionItem() {
        this.type = ActionType.thankYou;
        this.getActionTypeName = function () {
            return 'ThankYou';
        };
    }
    return ThankYouActionItem;
}());
exports.ThankYouActionItem = ThankYouActionItem;
var NoteResultData = (function () {
    function NoteResultData() {
    }
    return NoteResultData;
}());
exports.NoteResultData = NoteResultData;
var CustomIntegrationResultData = (function () {
    function CustomIntegrationResultData() {
    }
    return CustomIntegrationResultData;
}());
exports.CustomIntegrationResultData = CustomIntegrationResultData;
var DisclaimerResultData = (function () {
    function DisclaimerResultData() {
    }
    return DisclaimerResultData;
}());
exports.DisclaimerResultData = DisclaimerResultData;
var PrescreeningResultDataResponse = (function () {
    function PrescreeningResultDataResponse() {
    }
    return PrescreeningResultDataResponse;
}());
exports.PrescreeningResultDataResponse = PrescreeningResultDataResponse;
var PrescreeningResultDataAnswer = (function () {
    function PrescreeningResultDataAnswer() {
    }
    return PrescreeningResultDataAnswer;
}());
exports.PrescreeningResultDataAnswer = PrescreeningResultDataAnswer;
var PrescreeningResultDataSection = (function () {
    function PrescreeningResultDataSection() {
    }
    return PrescreeningResultDataSection;
}());
exports.PrescreeningResultDataSection = PrescreeningResultDataSection;
var PrescreeningResultData = (function () {
    function PrescreeningResultData() {
    }
    return PrescreeningResultData;
}());
exports.PrescreeningResultData = PrescreeningResultData;
var ContactInfoResultData = (function () {
    function ContactInfoResultData() {
        this.appliedWithLinkedIn = false;
    }
    return ContactInfoResultData;
}());
exports.ContactInfoResultData = ContactInfoResultData;
var PreferredCommunicationResultData = (function () {
    function PreferredCommunicationResultData() {
    }
    return PreferredCommunicationResultData;
}());
exports.PreferredCommunicationResultData = PreferredCommunicationResultData;
var ResumeResultData = (function () {
    function ResumeResultData() {
    }
    return ResumeResultData;
}());
exports.ResumeResultData = ResumeResultData;
var ContactDetailsResultData = (function () {
    function ContactDetailsResultData() {
    }
    return ContactDetailsResultData;
}());
exports.ContactDetailsResultData = ContactDetailsResultData;
var SocialResumeInfo = (function () {
    function SocialResumeInfo() {
    }
    return SocialResumeInfo;
}());
exports.SocialResumeInfo = SocialResumeInfo;
var ResumeStructureResultData = (function () {
    function ResumeStructureResultData() {
    }
    return ResumeStructureResultData;
}());
exports.ResumeStructureResultData = ResumeStructureResultData;
var SectionResultData = (function () {
    function SectionResultData() {
    }
    return SectionResultData;
}());
exports.SectionResultData = SectionResultData;
var ResumeEntry = (function () {
    function ResumeEntry() {
    }
    return ResumeEntry;
}());
exports.ResumeEntry = ResumeEntry;
var ResumeEntryValue = (function () {
    function ResumeEntryValue() {
    }
    return ResumeEntryValue;
}());
exports.ResumeEntryValue = ResumeEntryValue;
var AttachmentResultData = (function () {
    function AttachmentResultData() {
    }
    return AttachmentResultData;
}());
exports.AttachmentResultData = AttachmentResultData;
var SubmitResultData = (function () {
    function SubmitResultData() {
    }
    return SubmitResultData;
}());
exports.SubmitResultData = SubmitResultData;
var EEOQuestionsResultData = (function () {
    function EEOQuestionsResultData() {
        this.answers = new Array();
    }
    return EEOQuestionsResultData;
}());
exports.EEOQuestionsResultData = EEOQuestionsResultData;
var EEOQuestionUserResponse = (function () {
    function EEOQuestionUserResponse() {
    }
    return EEOQuestionUserResponse;
}());
exports.EEOQuestionUserResponse = EEOQuestionUserResponse;
var SaveWorkflowRequest = (function () {
    function SaveWorkflowRequest() {
    }
    return SaveWorkflowRequest;
}());
exports.SaveWorkflowRequest = SaveWorkflowRequest;
var SaveWorkflowResponse = (function () {
    function SaveWorkflowResponse() {
    }
    return SaveWorkflowResponse;
}());
exports.SaveWorkflowResponse = SaveWorkflowResponse;
var ThankYouResultData = (function () {
    function ThankYouResultData() {
    }
    return ThankYouResultData;
}());
exports.ThankYouResultData = ThankYouResultData;
var ValidateReferralRequest = (function () {
    function ValidateReferralRequest() {
    }
    return ValidateReferralRequest;
}());
exports.ValidateReferralRequest = ValidateReferralRequest;
var ValidateReferralResponse = (function () {
    function ValidateReferralResponse() {
    }
    return ValidateReferralResponse;
}());
exports.ValidateReferralResponse = ValidateReferralResponse;



//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent/work/8b1685a0cde68c49/src/models/application/index.ts
// module id = 17
// module chunks = 0 2